<template>
  <v-breadcrumbs
    class="px-8 pt-6 pb-0"
    style="background: transparent;"
  >
    <v-breadcrumbs-item
      class="font-weight-medium"
      :style="{ cursor: 'pointer', color: COLORS.grainfoxAIButton }"
      @click="$emit('back')"
    >
      Sinoa
    </v-breadcrumbs-item>
    <v-breadcrumbs-divider>
      <v-icon>
        mdi-chevron-right
      </v-icon>
    </v-breadcrumbs-divider>
    <v-breadcrumbs-item
      disabled
    >
      History
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
import { COLORS } from '@/helpers/colors';

export default {
  name: 'BreadcrumbGrainFoxHistory',

  data() {
    return {
      COLORS,
    };
  },
};
</script>
